import React from "react";

const Wallet = () => {
  return <div>Wallets</div>;
};

export default Wallet;
